import React from "react";
import { IProgram, IGroupedPrograms } from "./types";
import { filter, map } from "lodash";
import { getS3Url } from "../consts";

export const flyerRootPath = getS3Url("/images/gmccflyers/letter_size");

export const getTemplateFilePath = (order: number, fileName: string) => {
  return `${flyerRootPath}/Template_${order
    .toString()
    .padStart(2, "0")}_${fileName}`;
};

export const getOriginalFilePath = (order: number, fileName: string) => {
  const path = `${flyerRootPath}/${order
    .toString()
    .padStart(2, "0")}_${fileName}`;
  return path;
};

export const flyerAIVideoRootPath = "/images/gmccflyers/videos";

export const getAIVideoFilePath = (order: number, videoFileName: string) => {
  return `${flyerAIVideoRootPath}/${order
    .toString()
    .padStart(2, "0")}_${videoFileName}`;
};

export const programs: IProgram[] = [
  {
    order: 1,
    label: "GMCC - Jumbo Express",
    key: "gmcc_jumbo_express",
    value: "gmcc_jumbo_express",
    fileName: "GMCCJumboExpress.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 1,
    label: "GMCC - Diamond AUS ($10M)",
    key: "gmcc_diamond_aus",
    value: "gmcc_diamond_aus",
    fileName: "GMCCDiamondAUS.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 2,
    label: "GMCC - No Ratio Radiant - with Rates",
    key: "gmcc_no_ratio_radiant",
    value: "gmcc_no_ratio_radiant",
    fileName: "GMCCNoRatioRadiant.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 2,
    label: "GMCC - Radiant (No Income Doc) - with Rates",
    key: "gmcc_radiant_no_income_doc",
    value: "gmcc_radiant_no_income_doc",
    fileName: "GMCCNoRatioRadiant.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 3,
    label: "GMCC - Foreign Nationals",
    key: "gmcc_foreign_nationals",
    value: "gmcc_foreign_nationals",
    fileName: "GMCCForeignNationals.png",
    hasTemplate: true,
    hasOriginal: true,
    hasAIVideo: true,
    videoStreamingUrl:
      "https://drive.google.com/file/d/1on0UAsO6wqATrlI8xH_E78olw1XxBp3a/preview",
    videoDownloadUrl:
      "https://drive.google.com/uc?export=download&id=1on0UAsO6wqATrlI8xH_E78olw1XxBp3a",
  },
  {
    order: 4,
    label: "GMCC - 0% Down",
    key: "gmcc_0_percent_down",
    value: "gmcc_0_percent_down",
    fileName: "0PercentDown.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 5,
    label: "GMCC - 40% Down (No Income, No Employment needed) - with Rates",
    key: "gmcc_40_percent_down_no_income",
    value: "gmcc_40_percent_down_no_income",
    fileName: "40PercentDownNoIncome.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 5,
    label: "GMCC - Universe - with Rates",
    key: "gmcc_universe",
    value: "gmcc_universe",
    fileName: "40PercentDownNoIncome.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 6,
    label: "GMCC - Celebrity Jumbo",
    key: "gmcc_affluent_celebrity_20_low_rate",
    value: "gmcc_affluent_celebrity_20_low_rate",
    fileName: "GMCCAffluentCelebrity20LowRate.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 6,
    label: "GMCC - Asset as Income",
    key: "gmcc_asset_as_income",
    value: "gmcc_asset_as_income",
    fileName: "GMCCAffluentCelebrity20LowRate.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 7,
    label: "GMCC - Hermes (Alternatives) - with Rates",
    key: "gmcc_hermes_alternatives",
    value: "gmcc_hermes_alternatives",
    fileName: "GMCCHermesAlternatives.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 8,
    label: "GMCC - Universe CRA Outreach",
    key: "gmcc_universe_cra_outreach",
    value: "gmcc_universe_cra_outreach",
    fileName: "UniverseCRAOutreach.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 9,
    label: "GMCC - Buy Without Sell First",
    key: "gmcc_buy_without_sell_first",
    value: "gmcc_buy_without_sell_first",
    fileName: "BuyWithoutSellFirst.png",
    hasTemplate: true,
    hasOriginal: true,
    loVideos: {
      "vivian.wan@gmccloan.com": {
        streamingUrl: "https://drive.google.com/file/d/1W-a20aBRa4iym3cC__Gx0cgFHmzWMsUv/preview",
        downloadUrl: "https://drive.google.com/uc?export=download&id=1W-a20aBRa4iym3cC__Gx0cgFHmzWMsUv",
      },
      "yingjie@gmcc.com": {
        streamingUrl: "https://drive.google.com/file/d/1W-a20aBRa4iym3cC__Gx0cgFHmzWMsUv/preview",
        downloadUrl: "https://drive.google.com/uc?export=download&id=1W-a20aBRa4iym3cC__Gx0cgFHmzWMsUv",
      },
      "jma@gmccloan.com": {
        streamingUrl: "https://drive.google.com/file/d/1k4cI0QuXvdPcVapQgevMXaGraXNPaHJZ/preview",
        downloadUrl: "https://drive.google.com/uc?export=download&id=1k4cI0QuXvdPcVapQgevMXaGraXNPaHJZ",
      },
      "jjin@gmccloan.com": {
        streamingUrl: "https://drive.google.com/file/d/1k4cI0QuXvdPcVapQgevMXaGraXNPaHJZ/preview",
        downloadUrl: "https://drive.google.com/uc?export=download&id=1k4cI0QuXvdPcVapQgevMXaGraXNPaHJZ",
      },
    },
  },
  {
    order: 10,
    label: "GMCC - Bank Statement Self Employed",
    key: "gmcc_bank_statement_self_employed",
    value: "gmcc_bank_statement_self_employed",
    fileName: "BankStatementSelfEmployed.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 10,
    label: "GMCC - 10% Bank Statement ($3M)",
    key: "gmcc_10percent_bank_statement",
    value: "gmcc_10percent_bank_statement",
    fileName: "BankStatementSelfEmployed.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 11,
    label: "GMCC - DSCR",
    key: "gmcc_dscr",
    value: "gmcc_dscr",
    fileName: "DSCR.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 13,
    label: "GMCC - Celebrity $10K Grant",
    key: "gmcc_free_10k",
    value: "gmcc_free_10k",
    fileName: "Free10K.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  // {
  //   order: 14,
  //   label: "GMCC - Free $15K",
  //   key: "gmcc_free_15k",
  //   value: "gmcc_free_15k",
  //   fileName: "Free15K.png",
  //   hasTemplate: true,
  //   hasOriginal: true,
  //   loVideos: {
  //     "jma@gmccloan.com": {
  //       streamingUrl: "https://drive.google.com/file/d/1S7fS4RRIZLyPVVYz4e6OME2XELAGSodI/preview",
  //       downloadUrl: "https://drive.google.com/uc?export=download&id=1S7fS4RRIZLyPVVYz4e6OME2XELAGSodI",
  //     },
  //     "jjin@gmccloan.com": {
  //       streamingUrl: "https://drive.google.com/file/d/1S7fS4RRIZLyPVVYz4e6OME2XELAGSodI/preview",
  //       downloadUrl: "https://drive.google.com/uc?export=download&id=1S7fS4RRIZLyPVVYz4e6OME2XELAGSodI",
  //     },
  //   },
  // },

  {
    order: 17,
    label: "GMCC - Diamond Community",
    key: "gmcc_diamond_community_lending",
    value: "gmcc_diamond_community_lending",
    fileName: "GMCCDiamondCommunityLending.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 18,
    label: "GMCC - Grandslam",
    key: "gmcc_grandslam",
    value: "gmcc_grandslam",
    fileName: "GMCCGrandslam.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 19,
    label: "GMCC - Conforming Special",
    key: "gmcc_conforming_special",
    value: "gmcc_conforming_special",
    fileName: "GMCCConformingSpecial.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 20,
    label: "GMCC - WVOE and P&L",
    key: "gmcc_wvoe_and_p_and_l",
    value: "gmcc_wvoe_and_p_and_l",
    fileName: "WVOEAndPAndL.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 21,
    label: "GMCC - Special Buy Down",
    key: "gmcc_special_buy_down",
    value: "gmcc_special_buy_down",
    fileName: "GMCCSpecialBuyDown.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 22,
    label: "GMCC - Jumbo CRA Program - with Rates",
    key: "gmcc_jumbo_cra_program",
    value: "gmcc_jumbo_cra_program",
    fileName: "JumboCRA.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 23,
    label: "GMCC - Jumbo CRA Program - without Rates",
    key: "gmcc_jumbo_cra_program_without_rates",
    value: "gmcc_jumbo_cra_program_without_rates",
    fileName: "JumboCRAWithoutRates.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 24,
    label: "GMCC - Prime First $7500 Credit",
    key: "gmcc_prime_first",
    value: "gmcc_prime_first",
    fileName: "GMCCPrimeFirst.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 25,
    label: "GMCC - Ocean - with Rates",
    key: "gmcc_ocean",
    value: "gmcc_ocean",
    fileName: "GMCCOcean.png",
    hasTemplate: true,
    hasOriginal: true,
    unseeable: false, // mark as true if you want to hide this program from the user
  },
  {
    order: 26,
    label: "GMCC - Ocean - without Rates",
    key: "gmcc_ocean_without_rates",
    value: "gmcc_ocean_without_rates",
    fileName: "GMCCOceanWithoutRates.png",
    hasTemplate: true,
    hasOriginal: true,
    unseeable: false,
  },
  {
    order: 27,
    label: "GMCC - Fabulous Jumbo - with Rates",
    key: "gmcc_fabulous_jumbo",
    value: "gmcc_fabulous_jumbo",
    fileName: "GMCCFabulous.png",
    hasTemplate: true,
    hasOriginal: true,
    unseeable: false,
  },
  {
    order: 28,
    label: "GMCC - Fabulous Jumbo - without Rates",
    key: "gmcc_fabulous_jumbo_without_rates",
    value: "gmcc_fabulous_jumbo_without_rates",
    fileName: "FabulousWithoutRates.png",
    hasTemplate: true,
    hasOriginal: true,
    unseeable: false,
  },
  {
    order: 29,
    label: "GMCC - DSCR 3-2-1 Temporary Buydown",
    key: "gmcc_dscr_3_2_1_temporary_buydown",
    value: "gmcc_dscr_3_2_1_temporary_buydown",
    fileName: "DSCRTempBuydown.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 30,
    label: "GMCC - Amazing Jumbo - with Rates",
    key: "gmcc_amazing_jumbo",
    value: "gmcc_amazing_jumbo",
    fileName: "Amazing.png",
    hasTemplate: true,
    hasOriginal: true,
    unseeable: false,
  },
  {
    order: 31,
    label: "GMCC - Amazing Jumbo - without Rates",
    key: "gmcc_amazing_jumbo_without_rates",
    value: "gmcc_amazing_jumbo_without_rates",
    fileName: "AmazingWithoutRates.png",
    hasTemplate: true,
    hasOriginal: true,

  },
  {
    order: 32,
    label: "GMCC - Thunder - with Rates",
    key: "gmcc_thunder",
    value: "gmcc_thunder",
    fileName: "Thunder.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 33,
    label: "GMCC - Thunder - without Rates",
    key: "gmcc_thunder_without_rates",
    value: "gmcc_thunder_without_rates",
    fileName: "ThunderWithoutRates.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 34,
    label: "GMCC - Neptune",
    key: "gmcc_neptune",
    value: "gmcc_neptune",
    fileName: "Neptune.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 35,
    label: "GMCC - Mercury",
    key: "gmcc_mercury",
    value: "gmcc_mercury",
    fileName: "Mercury.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 36,
    label: "GMCC - Celebrity Forgivable $10K",
    key: "gmcc_forgivable_10k",
    value: "gmcc_forgivable_10k",
    fileName: "Forgivable.png",
    hasTemplate: true,
    hasOriginal: true,
  },
  {
    order: 37,
    label: "GMCC - Massive",
    key: "gmcc_massive",
    value: "gmcc_massive",
    fileName: "Massive.png",
    hasTemplate: true,
    hasOriginal: true,
  },
];

const keyToProgramMap = new Map(programs.map((p) => [p.key, p]));

const LuxuryProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_luxury",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Luxury Open House"
  ),
  title: "Luxury Open House",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_asset_as_income",
    "gmcc_universe",
    "gmcc_radiant_no_income_doc",
    "gmcc_diamond_aus",
    "gmcc_buy_without_sell_first",
    "gmcc_10percent_bank_statement",
    "gmcc_massive",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_luxury",
  })),
};

const AssetAsIncomeProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_asset",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Asset as Income"
  ),
  title: "Asset as Income",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_asset_as_income",
    "gmcc_neptune",
    "gmcc_mercury",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_asset",
  })),
};

const HighTechProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_high_tech",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "High-Tech Buyer"
  ),
  title: "High-Tech Buyer",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_thunder",
    "gmcc_fabulous_jumbo",
    "gmcc_amazing_jumbo",
    "gmcc_affluent_celebrity_20_low_rate",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_high_tech",
  })),
};

const HighNetWorthProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_high_net_worth",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "High-Net-Worth Clients"
  ),
  title: "High-Net-Worth Clients",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_asset_as_income",
    "gmcc_dscr",
    "gmcc_massive",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_high_net_worth",
  })),
};

const RentalInvestorProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_rental_investor",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Real Estate / Rental Investor"
  ),
  title: "Real Estate / Rental Investors",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_dscr",
    "gmcc_10percent_bank_statement",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_rental_investor",
  })),
};

const SelfEmployedProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_self_employed",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Self-Employed Borrowers"
  ),
  title: "Self-Employed Borrowers",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_10percent_bank_statement",
    "gmcc_hermes_alternatives",
    "gmcc_ocean",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_self_employed",
  })),
};

const FTHBProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_fthb",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "First-Time Homebuyers / Primary Residence Buyers"
  ),
  title: "First-Time Homebuyers / Primary Residence Buyers",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_free_10k",
    "gmcc_forgivable_10k",
    "gmcc_diamond_community_lending",
    "gmcc_grandslam",
    "gmcc_conforming_special",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_fthb",
  })),
};


const Top7ProgramsGrouped: IGroupedPrograms = {
  key: "GMCC_top_7",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "GMCC Top 11"
  ),
  title: "GMCC Top 11",
  // For options, we need to add a suffix to the key to make it unique, the values
  // are kept the same, so we can use the value to identify the program and display it
  options: [
    "gmcc_thunder",
    "gmcc_amazing_jumbo",
    "gmcc_fabulous_jumbo",
    "gmcc_40_percent_down_no_income",
    "gmcc_free_10k",
    "gmcc_foreign_nationals",
    "gmcc_buy_without_sell_first",
    "gmcc_jumbo_express",
    "gmcc_grandslam",
    "gmcc_dscr",
    "gmcc_wvoe_and_p_and_l",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_gmcc_top_7",
  })),
};

const CommunityLendingCRAGrouped: IGroupedPrograms = {
  key: "Community Lending/CRA",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Community Lending/CRA"
  ),
  title: "Community Lending/CRA",
  options: [
    "gmcc_diamond_community_lending",
    "gmcc_conforming_special",
    "gmcc_0_percent_down",
    "gmcc_free_10k",
    "gmcc_forgivable_10k",
    "gmcc_jumbo_cra_program",
    "gmcc_jumbo_cra_program_without_rates",
    "gmcc_grandslam",
    "gmcc_prime_first",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_community_lending_cra",
  })),
};

const CronusProgramsGrouped: IGroupedPrograms = {
  key: "Cronus",
  label: React.createElement(
    "div",
    { style: { fontSize: "15px", color: "#325ceb" } },
    "Cronus"
  ),
  title: "Cronus",
  options: [
    "gmcc_grandslam",
    "gmcc_jumbo_cra_program",
    "gmcc_jumbo_cra_program_without_rates",
    "gmcc_conforming_special",
  ].map((key) => ({
    ...keyToProgramMap.get(key),
    key: key + "_cronus",
  })),
};

export const groupedPrograms: (IGroupedPrograms | IProgram)[] = [
  LuxuryProgramsGrouped,
  AssetAsIncomeProgramsGrouped,
  HighTechProgramsGrouped,
  HighNetWorthProgramsGrouped,
  RentalInvestorProgramsGrouped,
  SelfEmployedProgramsGrouped,
  FTHBProgramsGrouped,
  Top7ProgramsGrouped,
  CommunityLendingCRAGrouped,
  CronusProgramsGrouped,
  ...filter(programs, (p) => {
    return (
      !map(Top7ProgramsGrouped.options, "value").includes(p.value) &&
      !map(CommunityLendingCRAGrouped.options, "value").includes(p.value) &&
      !map(CronusProgramsGrouped.options, "value").includes(p.value) &&
      !map(LuxuryProgramsGrouped.options, "value").includes(p.value) &&
      !map(HighTechProgramsGrouped.options, "value").includes(p.value) &&
      !map(HighNetWorthProgramsGrouped.options, "value").includes(p.value) &&
      !map(RentalInvestorProgramsGrouped.options, "value").includes(p.value) &&
      !map(SelfEmployedProgramsGrouped.options, "value").includes(p.value) &&
      !map(FTHBProgramsGrouped.options, "value").includes(p.value) &&
      !p.unseeable
    );
  }),
];

export const keyToProgram = (key: string): IProgram | undefined => {
  const program = keyToProgramMap.get(key);
  if (!program) {
    console.error(`Program with key ${key} not found`);
  }
  return program;
};
